import { GET, POST, PUT, DELETE } from '@/axios';

export async function getVulnerabilities() {

    try {

        return await GET('vulnerabilities');

    } catch (error) {

        console.warn();
        throw error;

    }

}

export async function showVulnerability(vulnerabilityId) {

    try {

        return await GET(`vulnerability/${vulnerabilityId}`);

    } catch (error) {

        console.warn();
        throw error;

    }

}

export async function createVulnerability(vulnerabilityData) {

    try {

        return await POST('vulnerabilities', vulnerabilityData);

    } catch (error) {

        console.warn();
        throw error;
    }

}

export async function updateVulnerability(vulnerabilityData, vulnerabilityId) {

    try {

        return await PUT(`vulnerabilities/${vulnerabilityId}`, vulnerabilityData);

    } catch (error) {

        console.warn();
        throw error;

    }

}

export async function deleteVulnerability(vulnerabilityId) {

    try {

        return await DELETE(`vulnerabilities/${vulnerabilityId}`);

    } catch (error) {

        console.warn();
        throw error;

    }

}

export async function excelImportVulnerabilities(file) {

    try {

        return await POST('vulnerabilities/import-vulnerabilities-excel', file, {

            headers: { "Content-Type": "multipart/form-data" },

        });

    } catch (error) {

        console.warn();
        throw error;

    }

}